import ScheduleOutlined from '@mui/icons-material/ScheduleOutlined';
import { IAbsenteeismRateItem } from '../../../interfaces/IAbsenteeismRate';
import { AbsenteeismRateCard } from './AbsenteeismRateCard';

export const RankWorkShiftWithMoreMedicalCertificate = ({ data }: { data: IAbsenteeismRateItem[] }) => (
  <AbsenteeismRateCard
    icon={<ScheduleOutlined />}
    title="Taxa de absenteísmo por turno"
    subtitle="Colaboradores com atestado sobre o total do turno da escala"
    data={data}
  />
);
